require('./app.less');
require('./vendor-dll-globals-fix.js');

var $ = require('jquery');

require('datatable-common-styles.less');
require('coolfit/datatables/datatables-processing');

require('select2-bootstrap-theme');
$.fn.select2.defaults.set("theme", "bootstrap");

var hb = require('handlebars/dist/handlebars.runtime.js');

$(document).ready(function () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        $('body').addClass('mobile');
    } else {
        $('body').addClass('desktop');
    }

    var url = window.location.href;
    url = url.toLowerCase()
    if (url.indexOf("/befit") > -1) {
        $('body').addClass('befit');
    }

    if (url.indexOf("/luxfit") > -1) {
        $('body').addClass('luxfit');
    }

    var currentLang = getCookie("lang");
    if (currentLang == "") {
        setCookie("lang", "BG", 3650);
    }
    if (currentLang == "BG") {
        $('body').addClass('bg');
    } else {
        $('body').addClass('en');
    }

    $(".changeLangText").click(function () {
        var currentLang = getCookie("lang");
        if (currentLang == "BG") {
            setCookie("lang", "EN", 365);
        } else {
            setCookie("lang", "BG", 365);
        }

        location.reload();
    });

    $("#cookies-agree").on("click", function () {
        setCookie("CookiesAccepted", "true", 3650);
        $(".cookie-footer").hide();
    });

    $('.nav-toggle').on('click', function (e) {
        $('.navbar').toggleClass('show-menu');
    });

    $(document).on('click', '.mobile .main-menu ul li a', function (e) {
        var li = $(this).parent('li');

        if (li.find('ul').length) {
            e.preventDefault();
            if (!li.is('.show-dropdown')) {
                li.addClass('show-dropdown').siblings('.show-dropdown').removeClass('show-dropdown');
            } else {
                li.removeClass('show-dropdown');
            }
        }
    })

    

    $('.gymfilter-wrap span').on('click', function () {
        $('.body-content').toggleClass('show-filter');
    });

    $('.section-video .play-btn').on('click', function (e) {
        e.preventDefault();
        var videohref = $(this).attr('href');
        $("#video").attr('src', '//www.youtube.com/embed/AskTDPiG5RY?rel=0&autoplay=1');
        $('.section-video .popup-wrapper').addClass('show-video');
    });

    $('.section-video .video-outer-wrapper .close-popup').on('click', function (e) {
        e.preventDefault();
        $('.section-video .popup-wrapper').removeClass('show-video');
        $("#video").attr('src', '');
    });

    

    $(document).on('click', '.btn-store', function (e) {
        e.preventDefault();

        var href = $(this).attr('href');
        var fit = $(this).data('fit');
        setCookie("fit", fit, 1);
        window.location.replace(href);
    })
});

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
}


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/app.js
// module id = 0
// module chunks = 1